import HelperService from "../../services/helper-service";
import {AppRoutes, AttachmentTypes, BuildingOwnershipTypes, BuildingStatTypes} from "../../utils/constants";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import BuildingStatWidgetContent from "./building-stat-widget-content";
import FormatService from "../../services/format-service";
import BuildingStatYieldWidget from "./building-stat-yield-widget";
import BuildingStatShareWidget from "./building-stat-share-widget";

export default function BuildingPortfolioScrolling({ building, ...props}) {
  const [cover, setCover] = useState();


  function onLinkedScroll(event){
    const target = event.target;
    const offset = target.scrollLeft;
    const linkedElements = document.getElementsByClassName('linked-scrolling');
    //link the scrollbars
    Object.values(linkedElements).map((el)=>{
     el.scrollLeft = offset;

     //affix the title
      const affix = target.getElementsByClassName('scrolling-item-affix')[0];
      const bbox = affix.getBoundingClientRect();

      if (offset > bbox.x){
        el.classList.add('affixed');
      } else {
        el.classList.remove('affixed');
      }
    });
  }

  useEffect(()=>{
    const linkedElements = document.getElementsByClassName('linked-scrolling');
    if (linkedElements){
      Object.values(linkedElements).map((el)=>{
        el.onscroll = el.onscroll || onLinkedScroll;
      });
    }

    if (building){
      let ci = HelperService.getObjByKey(building.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);
    } else {
      setCover(null);
    }
  }, [building]);


  return (
      <>
        <div className={"portfolio-scrolling-wrapper linked-scrolling"}>
          {cover && <div className="scrolling-item">
            <div className="building-portfolio-row-card">
              <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
                <img src={cover?.url} alt="" style={{maxWidth: '100%'}} />
              </Link>
            </div>
          </div>}
          <div className="scrolling-item scrolling-item-affix">
            <div className="building-portfolio-row-card">
              <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
                <h3>{building.title}</h3>
                <span className={`badge badge-lg bg-${HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).color}`}>{HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).title}</span>
              </Link>
            </div>
          </div>
          <BuildingStatShareWidget shares={building?.shares} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacity.val)} buildingId={building.id} containerClass={"scrolling-item scrolling-extended-item"} widgetClass={'building-portfolio-row-card'}
                                     second={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityReserved.val)}
                                     third={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityAccepted.val)}
                                     fourth={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityFree.val)}
          />
          <BuildingStatYieldWidget containerClass={'scrolling-item building-portfolio-row-card'} stats={building.stats} buildingId={building.id} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.parkingPlaces.val)} buildingId={building.id} containerClass={"scrolling-item bg-success text-white"} widgetClass={'building-portfolio-row-card border-0'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.repairFund.val)} buildingId={building.id} containerClass={"scrolling-item bg-indigo text-white"} widgetClass={'building-portfolio-row-card border-0'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.lentArea.val)} buildingId={building.id} containerClass={"scrolling-item"} widgetClass={'building-portfolio-row-card'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.rent.val)} buildingId={building.id} containerClass={"scrolling-item scrolling-extended-item"} widgetClass={'building-portfolio-row-card'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.profit.val)} buildingId={building.id} containerClass={"scrolling-item scrolling-extended-item"} widgetClass={'building-portfolio-row-card'} />
          <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.buildingValue.val)} buildingId={building.id} containerClass={"scrolling-item"} widgetClass={'building-portfolio-row-card'} />
        </div>
      </>
  );
}
